// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uhD0x","colBig":"styles_colBig__1-d-K","colSmall":"styles_colSmall__pQEBL"};